import api from './api';

const exchangeRateAdminService = {
  list(params = {}) {
    return api.get('/admin/exchange-rates', { params }).then((res) => res.data);
  },

  sync(payload = {}) {
    return api.post('/admin/exchange-rates/sync', payload).then((res) => res.data);
  },

  recalcLatest() {
    return api.get('/admin/dual-currency-recalc-runs/latest').then((res) => res.data);
  },

  recalcStart() {
    return api.post('/admin/dual-currency-recalc-runs/start').then((res) => res.data);
  },

  recalcResume() {
    return api.post('/admin/dual-currency-recalc-runs/resume').then((res) => res.data);
  },
};

export default exchangeRateAdminService;
